/**
 * Formatting-related constants used across the application.
 *
 * The formatting locale is read lazily from the runtime-config registry
 * (`getRuntimeConfig().formattingLocale`) by callers that need it; it is no longer a static
 * module-scope export because it arrives via the bootstrap fetch (ADR 0003).
 */

export const DEFAULT_FRACTION_DIGITS = 2;
export const WEIGHT_DECIMAL_DIGITS = 3;
export const DEFAULT_UNIT_SYMBOL = "kg";

export const ENGLISH_LOCALE_CODE = "en";
export const FALLBACK_DECIMAL_SEPARATOR = ",";
export const FALLBACK_THOUSAND_SEPARATOR = ".";
export const POINT_DECIMAL_SEPARATOR = "point";
export const COMMA_DECIMAL_SEPARATOR = "comma";
export const FALLBACK_DATE_FORMAT = "DD.MM.YYYY";
export const FALLBACK_DATETIME_FORMAT = "DD.MM.YYYY hh:mm";
export const FALLBACK_TIME_FORMAT = "hh:mm";

// Special characters
export const NBSP = "\xa0";
export const NON_BREAKING_HYPHEN = "\u2011";
